import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Subject';
import { VMwareProducts } from '../models/vmwareproducts';
import { ProductReleases } from '../models/productreleases';
import { MaximumCategory } from '../models/maximumcategory';
import { MaximumSubCategory } from '../models/maximumsubcategory';
import { CategoryDataRecord } from '../models/categorydatarecord';
import { CategoriesRecord } from '../models/categoriesrecord';
import { ConfigMaxSet } from '../models/configmaxset';
import { AuthHttp } from 'angular2-jwt';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { NumberConstants } from "../common/numberconstants";
import { EnvironmentsService } from 'app/services/enviornment.service';
import { HttpHeaders } from '@angular/common/http';
import { pdfMakeJapanese } from 'app/common/pdf/japanese-fonts';
import { pdfMakeChinese } from 'app/common/pdf/chinese-fonts';



@Injectable()

export class ReportsService {

  private notify = new Subject<any>();
  private baseServiceProvider;
  /**
   * Observable string streams
   */
  
  notifyObservable$ = this.notify.asObservable();
  public maximumsCats1Selected: any[] = new Array();
  public maximumsSubCats1Selected: any[] = new Array();
  public selectedMaximumTitle: String;
  public selectedprodID: number = this.numberconstants.ZERO;
  public selectedversionID: number = this.numberconstants.ZERO;
  public selectedprods: any;
  public selectedprodsInCfSet: any;;
  public selectedversions: any;
  public selectedprodName: any;
  public selectedverName: any;
  public maximumssRight: any;
  public catId: number;
  public subcatId: number;
  public resorceactions: any;
  totalRecords: number;
  public categoriesArray: any[] = new Array();
  public selectedCategories: any;
  public selectedConfigSet: any;
  public roleIds: any;
  public authRoleIds: any;
  public _allCategories: any;
  public bookmarkLink: String;
  public selectedBookmarkedprod: String = "";
  public selectedBookmarkedversion: String = "";
  public selectedBookmarkedCategories: String = null;
  public selectedBookmarkedSubCategories: String = null;

  constructor(private authHttp: AuthHttp,
    private http: Http, private router: Router, private location: Location, private numberconstants: NumberConstants, private envService: EnvironmentsService) { }

  public getReleases(roleId: any): Observable<VMwareProducts[]> {
    let urlString: String = "limits/menutree/v1/vmwareproducts";
    if (null != roleId)
      urlString = "limits/menutree/v1/vmwareproducts?roleId=" + roleId
    return this.authHttp.get(this.envService.config.espApiLimits + urlString, { withCredentials: true }
    )
      .map((response: Response) => {
        //let releases = response.json();
        let releases = (<Array<any>>response.json()).sort((a,b)=>{ return a.id - b.id});
        return releases;
      });
  }



  public getProductVersions(productId: string, urlIndex: number): Observable<any[]> {
    let url: string = this.envService.config.espApiLimits + "limits/menutree/v1/vmwareproducts/" + productId;
    /**
     * urlIndex = 1 -> Extract all product release versions.
     * urlIndex = 2 -> Extract all new products release versions which doesn't have configuration maximum set.
     * urlIndex = 3 -> Extract all product release versions which have configuration maximum set.
     * urlIndex = 4 -> Extract all product release versions which have configuration maximum set and status is published
     */
    if (urlIndex === this.numberconstants.ALLPRODUCTS) {
      url += "/releases";
    } else if (urlIndex === this.numberconstants.HASNOCONFIGSET) {
      url += "/releases?hasconfigmaxset=false";
    } else if (urlIndex === this.numberconstants.HASCONFIGSET) {
      url += "/releases?hasconfigmaxset=true";
    } else if (urlIndex === this.numberconstants.HASCONFIGSETANDPUBLISHED) {
      url += "/releases?hasconfigmaxset=true&ispublished=true";
    }
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.get(url, { withCredentials: true })
        .map((response: Response) => {
          let prodVersions = response.json();
          return prodVersions;
        });
    } else {
      return this.authHttp.get(url, { withCredentials: true })
        .map((response: Response) => {
          let prodVersions = response.json();
          return prodVersions;
        });
    }
  }
  public getMaximumCategoriesByProductIdAndVersionId(prodId: number, versionId: number, isPublished: boolean = false): Observable<any> {
    let maxCatUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/" + prodId + "/releases/" + versionId + "/categories";
    if(isPublished){
      maxCatUrl+="?ispublished=true";
    }  
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.get(maxCatUrl, { withCredentials: true })
        .map((response: Response) => {
          let categories = response.json();
          return categories;
        });
    } else {
      return this.authHttp.get(maxCatUrl, { withCredentials: true })
        .map((response: Response) => {
          let categories = response.json();
          return categories;
        });
    }
  }

  public addConfigmaxset(configmaxset: ConfigMaxSet): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let configmaxSetUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/" + configmaxset.vmwProductId + "/releases/" + configmaxset.vmwProductReleaseId.join() + "/configmaxset";
    return this.authHttp.post(configmaxSetUrl,
      JSON.stringify(configmaxset), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let created = response.json();
        return created;
      });
  }

  public addMaximum(maximum: any, clonestatus: boolean): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maxCatCreateUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/";
    let max;
    if (!clonestatus) {
      max = {
        "accessType": maximum.accessType,
        "category": maximum.category,
        "child": maximum.child,
        "cmVmwProdRelId": maximum.cmVmwProdRelId,
        "cmVmwProductId": maximum.cmVmwProductId,
        "comments": maximum.description,
        "description": maximum.description,
        "devMember": maximum.devMember,
        "perfMember": maximum.perfMember,
        "primaryAuthor": maximum.primaryAuthor,
        "productManager": maximum.prodManager,
        "qeMember": maximum.qeMember,
        "secondaryAuthor": maximum.secondaryAuthor,
        "subCategory": maximum.subCategory,
        "subCatisSupport": maximum.isSupport,
        "subCatisselected": true,
        "subCattdecription": maximum.description,
        "support": maximum.isSupport,
        "updatedBy": maximum.updatedBy,
        "catSortType": maximum.catSortType,
        "catSelectedSortNumber": maximum.catSelectedSortNumber,
        "subCatSortType": maximum.subCatSortType,
        "subCatSelectedSortNumber": maximum.subCatSelectedSortNumber,
        "catSortorder": maximum.catSortorder,
        "subCatSortorder": maximum.subCatSortorder,
      }
      maxCatCreateUrl += max.cmVmwProductId + "/releases/" + max.cmVmwProdRelId + "/categories";
    } else {
      max = {
        "accessType": maximum.accessType,
        "child": maximum.child,
        "cloneCatid": maximum.clonecatId,
        "cloneSubcatid": maximum.clonesubCatId,
        "cloned": true,
        "cmVmwProdRelId": maximum.cmVmwProdRelId,
        "cmVmwProductId": maximum.cmVmwProductId,
        "comments": maximum.description,
        "description": maximum.description,
        "devMember": null,
        "perfMember": null,
        "primaryAuthor": maximum.primaryAuthor,
        "productManager": maximum.prodManager,
        "qeMember": null,
        "secondaryAuthor": maximum.secondaryAuthor,
        "subCategory": null,
        "subCatisSupport": true,
        "subCatisselected": true,
        "subCattdecription": maximum.description,
        "support": maximum.isSupport,
        "updatedBy": maximum.updatedBy,
        "cloneSourceCatid": maximum.cloneSourceCatid,
        "cloneTargetCatid": maximum.cloneTargetCatid,
        "catSortType": maximum.catSortType,
        "catSelectedSortNumber": maximum.catSelectedSortNumber,
        "subCatSortType": maximum.subCatSortType,
        "subCatSelectedSortNumber": maximum.subCatSelectedSortNumber,
        "catSortorder": maximum.catSortorder,
        "subCatSortorder": maximum.subCatSortorder,
      }

      maxCatCreateUrl += max.cmVmwProductId + "/releases/" + max.cmVmwProdRelId + "/categories";
    }
    return this.authHttp.post(maxCatCreateUrl,
      JSON.stringify(max), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let created = response.json();
        return created;
      });
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  getProducts(roleId: any): Observable<VMwareProducts[]> {
    let urlString: String = "limits/menutree/v1/vmwareproducts";
    if (null != roleId)
      urlString = "limits/menutree/v1/vmwareproducts?hasconfigmaxset=true&roleId=" + roleId;
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.get(this.envService.config.espApiLimits +
        urlString, { withCredentials: true }).map((response: Response) => {
         // let releases = response.json();
          let releases = (<Array<any>>response.json()).sort((a,b)=>{ return a.id - b.id});
          return releases;
        });
    } else {
      return this.authHttp.get(this.envService.config.espApiLimits +
        urlString, { withCredentials: true }).map((response: Response) => {
          // let releases = response.json();
          let releases = (<Array<any>>response.json()).sort((a,b)=>{ return a.id - b.id});
          return releases;
        });
    }
  }

  public getSuggestData(payload: any): Observable<any> {
    if (payload != undefined && payload != null && payload.toString().length > 3) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("token"));
      const requestOptions = {
        headers: headers,
      };
      const requestPayload = {
        "name": payload
      }
      return this.http.post(this.envService.config.empAdUrl +
        "v1/users", requestPayload, requestOptions)
        .map((response: Response) => {
          let suggestData = response.json();
          return suggestData;
        });
    } else {
      return Observable.empty()
    }
  }

  public getMatchingProducts(productname: any): Observable<any> {
    if (productname != undefined &&  productname!= null && productname.toString().length > 3) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("token"));
      const requestOptions = {
        headers: headers,
        withCredentials: true,
      };
      let matchingProdUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/releasemanager/matchingproduct?productname=" + productname;
      return this.http.get(matchingProdUrl, requestOptions)
        .map((response: Response) => {
          let suggestData = response.json();
          return suggestData;
        });
    } else {
      return Observable.empty()
    }
  }

  getComparisonTable(prodId: number, verId: number[], versionId: number): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let obj = {
      'vmwareProductId': prodId,
      'releaseIds': verId,
    }
    let compareUrl = this.envService.config.espApiLimits +
      "limits/comparelimits/v1/vmwareproducts/" + prodId + "/releases/" + versionId + "/configmaxset/comparision";
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.post(compareUrl,
        JSON.stringify(obj), { headers: headers, withCredentials: true })
        .map((response: Response) => {
          let compareTable = response.json();
          return compareTable;
        });
    } else {
      return this.authHttp.post(compareUrl,
        JSON.stringify(obj), { headers: headers, withCredentials: true })
        .map((response: Response) => {
          let compareTable = response.json();
          return compareTable;
        });
    }

  }

  addCategatoryData(cat: any): void {
    let categorydata: CategoryDataRecord = new CategoryDataRecord();
    categorydata.categoryId = cat;
    categorydata.subCategoryId = this.numberconstants.ZERO;
    this.categoriesArray.push(categorydata);
  }

  addSubCateoryData(cat: any, subCat: any): void {
    let categorydata: CategoryDataRecord = new CategoryDataRecord();
    categorydata.categoryId = cat;
    categorydata.subCategoryId = subCat.id;
    this.categoriesArray.push(categorydata);
  }

  getCategorieData(prodid: number, verid: number): CategoriesRecord {
    let categoriesData: CategoriesRecord = new CategoriesRecord();
    categoriesData.prodId = prodid;
    categoriesData.relId = verid;
    categoriesData.categories = this.categoriesArray;
    this.totalRecords = this.categoriesArray.length;
    return categoriesData;
  }

  addSubcategoriesToRightPanel(vmwaresubcategory, catId: number) {
    vmwaresubcategory.forEach(element => {
      const found = this.maximumsSubCats1Selected.indexOf(element.id);
      if (found == this.numberconstants.MINUS_ONE) {
        this.maximumsSubCats1Selected.push(element.id);
        let maxidsnodups = Array.from(new Set(this.maximumsSubCats1Selected));
        this.maximumsSubCats1Selected = maxidsnodups;
      }
      this.addSubCateoryData(catId, element);
    });
  }

  addToCategories(id: number) {
    const found = this.maximumsCats1Selected.indexOf(id);
    if (found == this.numberconstants.MINUS_ONE) {
      this.maximumsCats1Selected.push(id);
      let maxidsnodups = Array.from(new Set(this.maximumsCats1Selected));
      this.maximumsCats1Selected = maxidsnodups;
    }
  }

  getConfigSet(prodId: any, verId: any): Observable<any> {
    let configSetUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/" + prodId + "/releases/" + verId + "/configmaxset";
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.get(configSetUrl, { withCredentials: true })
        .map((response: Response) => {
          let configset = response.json();
          return configset;
        });
    } else {
      return this.authHttp.get(configSetUrl, { withCredentials: true })
        .map((response: Response) => {
          let configset = response.json();
          return configset;
        });
    }
  }

  updateCategoriesInMenutree(maximum: any, category: any, deleteMax: boolean): any {
    if (category != null) {
      category.subcategories = [];
    }
    this.selectedCategories.forEach(element => {
      if (element.id == maximum.categoryId) {
        if (element.subcategories != undefined && element.subcategories.length > this.numberconstants.ZERO) {
          element.subcategories.forEach(subelement => {
            subelement.updatedBy = JSON.parse(localStorage.getItem('currentUser')).email;
            if (subelement.id == maximum.subcategoryId) {
              if (deleteMax == true) {
                const index = element.subcategories.indexOf(subelement);
                element.subcategories.splice(index, this.numberconstants.ONE);
                if (element.subcategories.length == this.numberconstants.ZERO) {
                  const index = this.selectedCategories.indexOf(element);
                  this.selectedCategories.splice(index, this.numberconstants.ONE);
                }
              } else {
                element.category = category.category;
                subelement.subCategory = category.subCategory;
                subelement.category.category = category.category;
                category.subcategories.push(subelement);
              }
            }
          });
        } else {
          if (deleteMax == true) {
            const index = this.selectedCategories.indexOf(element);
            this.selectedCategories.splice(index, this.numberconstants.ONE);
          } else {
            element.category = category.category;
          }
        }
      }
    });
    this.notifyOther({
      option: "category",
      value: ""
    });
    return category;
  }

  getSelectedConfigset(): void {
    let arr: any = new Array();
    this.getConfigSet(this.selectedprodID, this.selectedversionID)
      .subscribe(configset => {
        if (configset.length > this.numberconstants.ZERO) {
          this.selectedConfigSet = configset[this.numberconstants.ZERO];
        }
      },
        err => {
          console.log(err)
        });
  }

  collectALLCategories(): any {
    this._allCategories[this.numberconstants.ZERO].rights.forEach(element => {
      if (element.child === false) {
        this.addToCategories(element.id);
        this.addCategatoryData(element.id);
      } else if (element.child === true) {
        this.addToCategories(element.id);
        this.addSubcategoriesToRightPanel(element.subcategories, element.id);
      }
    });
    return this.categoriesArray;
  }

  onBookMark(url: String, isGuest: boolean, isBookmark: boolean, isCat: boolean) {
    let categoryStrArray: any = [];
    let categoryStr = "";
    let subcategoryStr = "";
    let categorySubStrArray: any = [];
    this.categoriesArray.forEach(element => {
      if (element.subCategoryId > this.numberconstants.ZERO) {
        categoryStrArray.push(element.categoryId + "-" + element.subCategoryId);
      } else {
        categoryStrArray.push(element.categoryId + "-" + this.numberconstants.ZERO);
      }
      let categoryStrArraynoDups = Array.from(new Set(categoryStrArray));
      categoryStrArray = categoryStrArraynoDups;
    });
    categoryStr = categoryStrArray.toString();
    subcategoryStr = categorySubStrArray.toString();
    let querSting = url + "?vmwareproduct=" + this.selectedprodName + "&release=" + this.selectedverName;
    if (categoryStr.length > this.numberconstants.ZERO && isCat)
      querSting = querSting + "&categories=" + categoryStr;
    this.location.replaceState(querSting);
  }

  setBookMarkedSearch(bookmarkString: String): void {
    if (bookmarkString != undefined && bookmarkString.length > this.numberconstants.ZERO) {
      let strArray = bookmarkString.split("&")
      if (strArray[this.numberconstants.ZERO] != undefined && strArray[this.numberconstants.ZERO].length > this.numberconstants.ZERO)
        this.selectedBookmarkedprod = strArray[this.numberconstants.ZERO].split("=")[this.numberconstants.ONE];
      this.selectedBookmarkedprod = this.selectedBookmarkedprod.split('%20').join(' ');
      if (strArray[this.numberconstants.ONE] != undefined && strArray[this.numberconstants.ONE].length > this.numberconstants.ZERO)
        this.selectedBookmarkedversion = strArray[this.numberconstants.ONE].split("=")[this.numberconstants.ONE];
      this.selectedBookmarkedversion = this.selectedBookmarkedversion.split('%20').join(' ');
      if (strArray[this.numberconstants.TWO] != undefined && strArray[this.numberconstants.TWO].length > this.numberconstants.ZERO)
        this.selectedBookmarkedCategories = strArray[this.numberconstants.TWO].split("=")[this.numberconstants.ONE];
    }
  }

  setBookarkedCategoriesSelected(catList: any): void {
    if (catList != undefined) {
      let catArr = this.selectedBookmarkedCategories.split(",");
      catArr.forEach(element => {
        let idArray = element.split("-");
        let catId = parseInt(idArray[this.numberconstants.ZERO]);
        let subCatId = parseInt(idArray[this.numberconstants.ONE]);
        catList.forEach(catElement => {
          if (catId === catElement.id && (catElement.subcategories == undefined || catElement.subcategories.length == this.numberconstants.ZERO || subCatId == this.numberconstants.ZERO)) { //for Cagories having maximums without subcategory=0
            catElement.selected = true;
          } else if (catId === catElement.id && catElement.subcategories.length > this.numberconstants.ZERO) {
            let count = this.numberconstants.ZERO;
            catElement.subcategories.forEach(subElement => {
              if (subCatId === subElement.id) {
                subElement.selected = true;
                catElement.expanded = true;
              }
            });

          }
        });
      });
      this.selectedBookmarkedCategories = null;
    }
  }

  setSelectedCategories(bookmarkString: string, catList: any) {
    if (this.selectedBookmarkedCategories != null &&
      this.selectedBookmarkedCategories.length > this.numberconstants.ZERO) {
      let catArr = this.selectedBookmarkedCategories.split(",");
      catArr.forEach(element => {
        let catStr: any = element.split("-");
        let subCat: MaximumSubCategory = new MaximumSubCategory();
        subCat.id = parseInt(catStr[this.numberconstants.ONE]);
        if (subCat.id == this.numberconstants.ZERO)
          this.addCategatoryData(parseInt(catStr[this.numberconstants.ZERO]));
        else
          this.addSubCateoryData(parseInt(catStr[this.numberconstants.ZERO]), subCat);
      });
      this.location.replaceState(bookmarkString);
      this.setBookarkedCategoriesSelected(catList);
    }
  }

  public getFontFiles(fontFileName: any){
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append('Accept', 'text/html, application/xhtml+xml, */*');
    const requestOptions = {
      headers: headers,
    };
    let fontUrl =  this.envService.config.whitneyAssetsUrl + fontFileName;
    this.http.get(fontUrl, requestOptions)
     .subscribe((data: any) => {
        let localeClass = null;
        let locale = localStorage.getItem("configmax-lang");
        if(locale == "ja"){
          localeClass = pdfMakeJapanese;
        }
        else if(locale == "zh"){
          localeClass = pdfMakeChinese;
        }
        if(localeClass != null){
          localeClass.vfs = {
                  "Roboto-Italic.ttf": data._body,
                  "Roboto-Medium.ttf": data._body,
                  "Roboto-MediumItalic.ttf": data._body,
                  "Roboto-Regular.ttf": data._body
          };
        }
        });
  }
  loadFontFiles(){
    if(localStorage.getItem('configmax-lang') === 'zh'){
        this.getFontFiles("zh-Roboto-Italic.jpg");
    }
    else if(localStorage.getItem('configmax-lang') === 'ja'){
        this.getFontFiles("jp-Roboto-Italic.jpg");
    }
}
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts